// extracted by mini-css-extract-plugin
export default {"btn__click":"Button_btn__click__IkjLY"};